import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"
import { useSignal } from "@preact/signals-react"
import { tableFormsData } from "Pages/Admin/OfficeMapping/@signals"


export default function OfficeMappingTableField({ label, value, rowIndex }) {
	const formValue = useSignal(value)

	useEffect(() => {
		tableFormsData.value = { ...tableFormsData.value, [rowIndex]: { ...tableFormsData.value[rowIndex], [label]: formValue.value } }
	}, [formValue.value])

	return <TextFieldSeeker
		label={label}
		value={formValue.value}
		onChange={e => {
			formValue.value = e.target.value
		}}
		sx={{
			maxWidth: 1 / 5
		}}
	/>
}